import { render, staticRenderFns } from "./WideEducationData.vue?vue&type=template&id=68b89b94&scoped=true&"
import script from "./WideEducationData.vue?vue&type=script&lang=js&"
export * from "./WideEducationData.vue?vue&type=script&lang=js&"
import style0 from "./WideEducationData.vue?vue&type=style&index=0&id=68b89b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b89b94",
  null
  
)

export default component.exports